import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import profile from "../../img/profile.png";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { personalinfo } from "../../functions/auth"
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({

    container: {
        margin: "45px 0 0 0",
        // margin: "100px 0 0 0",
        width: "369px",
        padding: "30px",
        borderRadius: "20px",
        background: "#fff",
        boxShadow: "3px 3px 12px #ddd",
    },
    box: {
        margin: "20px 0px 20px",
        background: "#f3f3f3",
        paddingTop: "24px",
        textAlign: "center"
    },

    mypage: {

        float: "left",
        textDecoration: "none",
        color: "#000",
        // lineHeight: "30px",
        display: "flex",
        alignItems: "center"


    },

    logout: {
        float: "right",
        textDecoration: "none",
        color: "#000",
        lineHeight: "32px",
        display: "flex",
        alignItems: "center"


    },

    info: {
        marginTop: "40px",

    },
    profile: {


        width: "101px",
        height: "101px",
        borderRadius: "50%",
        backgroundColor: "#f0f0f0",


    },
    detail: {
        display: "inline-block",
        marginLeft: "30px",
        width: "235px",
        overflow: "hidden",


    },

    nick: {
        color: "#000",
        fontSize: "20px",
        lineHeight: "40px",
        fontWeight: 500

    },
    id: {
        color: "#999",
        fontSize: "15px",
        fontWeight: 400,
        lineHeight: "30px",
    },
    credit: {
        color: theme.palette.primary.main,
        fontSize: "30px",
        lineHeight: "45px",


    },
    paragraph: {

        fontSize: "14px",
        color: "#666",
        lineHeight: "20px"

    },
    button: {
        width: "100%",
        height: "45px",
        color: "#fff",
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "6px",
        fontSize: "20px",
        marginTop: "15px",
        padding: "0px",
        border: "0px",
        "&:hover": {
            cursor: 'pointer'
        }

    }





}))
const LoggedIn = () => {

    const style = useStyles();

    const [user, setUser] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        personalinfo().then(res => {
            setUser(res);
        })

        // console.log(user)

        return;

    }, [])

    const logout = () => {
        window.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_KEY}`);
        dispatch({
            type: "LOGOUT",
            payload: null
        })
    }



    return (
        <div className={style.container}>

            <Link className={style.mypage} to="/mypage"> <AccountCircleOutlinedIcon fontSize="large" />마이페이지</Link>
            <Link className={style.logout} to="/" onClick={logout}>   <ExitToAppIcon fontSize="large" />로그아웃</Link>


            <div className={style.info}>
                <img src={profile} alt="profile" className={style.profile} />
                <div className={style.detail}>

                    <div className={style.nick}>{user.name}</div>
                    <div className={style.id}>{user.userID}</div>
                    <div className={style.credit}>{user.points} 크레딧</div>
                </div>
            </div>

            <p className={style.paragraph}>
                설문 1회 참여시 1크레딧을 얻을 수 있어요.<br />
                1크레딧으로 설문 게시글을 1회 업로드 할 수 있어요<br />
                (게시 기간은 3일 입니다.)
            </p>

            <Link to="/write/post" > <button className={style.button}>설문 작성하기</button></Link>

        </div>
    );
};

export default LoggedIn